<template>
  <div class="poli-tambah">
    <div class="app-content--inner p-0 d-flex flex-column">
      <div class="container-fluid __tambah-klinik">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-uppercase" style="color:#6190bf">
              tambah poliklinik
            </h3>
            <br />

            <b-form @submit.prevent="">
              <div class="card card-box">
                <div class="card-body p-5">
                  <b-row>
                    <b-col lg="3" md="12">
                      <b-form-group label-for="status" >
                        <template :v-slot="label">
                          <strong>Status Poliklinik</strong> <span class="text-danger">*</span>
                        </template>
                        <vue-select
                          style="font-size:13px"
                          :options="statusPoliklinik"
                          v-model="form.status"
                          placeholder="Pilih Status"
                        />
                        <span style="font-size:.85rem;color:red">{{
                          errForm.status
                        }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12">
                      <b-form-group label-for="nama-poli">
                        <template :v-slot="label">
                          <strong>Nama Poliklinik</strong> <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                          id="name"
                          v-model="form.nama"
                          @input="inputNama"
                          placeholder="Tulis Nama Poliklinik"
                          required
                        ></b-form-input>
                        <span style="font-size:.85rem;color:red">{{
                          errForm.nama
                        }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12">
                      <b-form-group label-for="location">
                        <template :v-slot="label">
                          <strong>Lokasi Poliklinik</strong> <span class="text-danger">*</span>
                        </template>
                        <vue-select
                          style="font-size:13px"
                          :options="locationList"
                          v-model="form.location"
                          placeholder="Tulis Lokasi Poliklinik"
                          :keyOpt="'substring'"
                          :isClearable="true"
                          @input="changeLocation($event)"
                        />
                        <span style="font-size:.85rem;color:red">{{
                          errForm.location
                        }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="3" md="12">
                      <b-form-group label-for="kategori-pasien">
                        <template :v-slot="label">
                          <strong>Kategori Pasien</strong> <span class="text-danger">*</span>
                        </template>
                        <vue-select-multiple
                          style="font-size:13px"
                          :options="kategoriPasien"
                          v-model="form.kategori"
                          placeholder="Pilih Kategori"
                          class="select-multiple"
                        />
                        <span style="font-size:.85rem;color:red">{{
                          errForm.kategori
                        }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12">
                      <b-form-group label-for="durasi">
                        <template :v-slot="label">
                          <strong>Durasi Konsultasi/Pasien</strong> <span class="text-danger">*</span>
                        </template>
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>menit</b-input-group-text>
                          </template>
                          <b-form-input
                            id="durasi"
                            type="number"
                            v-model="form.durasi"
                            @keydown="keydownDurasi"
                            placeholder="10"
                            required
                            min="1"
                            max="60"
                            step="1"
                          ></b-form-input>
                        </b-input-group>
                        <span style="font-size:.85rem;color:red">{{
                          errForm.durasi
                        }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12" v-show="bpjsAuthValid">
                      <b-form-group label-for="kode-poli">
                        <template :v-slot="label">
                          <strong>Kode Poliklinik BPJS</strong>
                        </template>
                        <vue-select
                          style="font-size:13px"
                          :options="poliBpjsList"
                          v-model="form.kode"
                          placeholder="Pilih Kode Poliklinik"
                          :keyOpt="'kode_dokter_bpjs'"
                          :isClearable="true"
                          @input="inputKode($event)"
                        />
                        <span style="font-size:.85rem;color:red">{{
                          errForm.kode
                        }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12" v-if="isEdit && satusehatAuthValid">                        
                      <div class="sync">
                        <b>Sync dengan SatuSehat</b>
                        <span class="ml-2">
                          <font-awesome-icon
                            v-if="synced"
                            :icon="['fas', 'check-circle']"
                            style="color: #1ad52f; font-size: 27px;"
                          />
                          <font-awesome-layers
                            v-else
                            style="font-size: 27px;"
                          >
                            <font-awesome-icon
                              :icon="['far', 'circle']"
                              style="opacity: 0.3;"
                            />
                            <font-awesome-icon
                              :icon="['fas', 'sync']"
                              transform="shrink-8"
                              style="color: #3772d7;cursor:default;"
                              spin
                              v-if="syncing"
                            />
                            <font-awesome-icon
                              v-else
                              @click="syncHandler"
                              :icon="['fas', 'sync']"
                              transform="shrink-8"
                              style="color: #3772d7;cursor: pointer;"
                            />
                          </font-awesome-layers>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Set Jadwal -->
                  <b-row class="py-5">
                    <b-col md="12">
                      <strong>Jadwal Poliklinik</strong> <span class="text-danger">*</span>
                    </b-col>
                    <b-col md="12">
                      <div v-for="(jadwal, indexJadwal) in form.jadwal" :key="indexJadwal">
                        <b-row>
                          <b-col lg="1" md="12" class="schedule-number text-center">
                            <div class="schedule-number">{{ indexJadwal + 1 }}.</div>
                          </b-col>
                          <b-col lg="3" md="12">
                            <b-form-group label-for="hari">
                              <template :v-slot="label">
                                <strong style="color:#fff">-</strong>
                              </template>
                              <vue-select-multiple
                                style="font-size:13px"
                                :options="optionHari"
                                v-model="jadwal.hari"
                                placeholder="Pilih Hari"
                                @input="inputHari($event, indexJadwal)"
                                class="select-multiple"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="2" md="12">
                            <b-form-group label-for="jam-mulai">
                              <template :v-slot="label">
                                <strong>Jam Mulai</strong>
                              </template>
                              <date-picker 
                                v-model="jadwal.jam_mulai" 
                                type="time" 
                                format="HH:mm"
                                @input="inputJamMulai"
                                placeholder="HH:MM"
                                >
                              </date-picker>
                            </b-form-group>
                          </b-col>
                          <b-col lg="2" md="12">
                            <b-form-group label-for="jam-selesai">
                              <template :v-slot="label">
                                <strong>Jam Selesai</strong>
                              </template>
                              <date-picker 
                                v-model="jadwal.jam_selesai" 
                                type="time" 
                                format="HH:mm"
                                @input="inputJamSelesai"
                                placeholder="HH:MM"
                                >
                              </date-picker>
                            </b-form-group>
                          </b-col>
                          <b-col class="schedule-button">
                            <b-button
                              variant="info"
                              style="padding: .5rem .8rem; border-radius: 100%;border-color:transparent"
                              class="mr-3"
                              @click="addJadwal()"
                            >
                              <font-awesome-icon icon="plus" />
                            </b-button>
                            <b-button
                              variant="danger"
                              style="padding: .4rem .7rem; border-radius: 100%"
                              v-if="indexJadwal > 0"
                              @click="deleteJadwal(indexJadwal)"
                            >
                              <font-awesome-icon icon="minus" />
                            </b-button>
                          </b-col>
                          <b-col lg="12">
                            <span style="font-size:.85rem;color:red">{{
                              errForm.jadwal[indexJadwal]
                            }}</span>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- End Set Jadwal -->
                  <b-row v-for="(dokter, indexDokter) in form.dokter" :key="indexDokter">
                    <b-col lg="3" md="12">
                      <b-form-group label-for="dokter">
                        <template :v-slot="label">
                          <strong>Tambah Dokter</strong><span class="text-danger">*</span>
                        </template>
                          <vue-select
                          style="font-size:13px"
                          :options="optionDokter"
                          v-model="form.dokter[indexDokter]"
                          placeholder="Pilih Nama Dokter"
                          @input="inputDokter"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col class="schedule-button">
                      <b-button
                        variant="info"
                        style="padding: .5rem .8rem; border-radius: 100%;border-color:transparent"
                        class="mr-3"
                        @click="addDokter()"
                      >
                        <font-awesome-icon icon="plus" />
                      </b-button>
                      <b-button
                        variant="danger"
                        style="padding: .4rem .7rem; border-radius: 100%"
                        v-if="indexDokter > 0"
                        @click="deleteDokter(indexDokter)"
                      >
                        <font-awesome-icon icon="minus" />
                      </b-button>
                    </b-col>
                    <b-col lg="12" v-if="errForm.dokter[indexDokter]">
                      <span style="font-size:.85rem;color:red">{{
                        errForm.dokter[indexDokter]
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-center mt-5">
                    <b-col lg="8" md="7" sm="6">&nbsp;</b-col>
                    <b-col lg="4" md="5" sm="6" align="right">
                      <b-button
                        class="text-capitalize mr-2"
                        variant="danger"
                        @click="tutup()"
                        >tutup</b-button
                      >
                      <b-button
                        class="text-capitalize"
                        variant="primary"
                        @click="selesai()"
                        >selesai</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus, faSync, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
library.add(faPlus, faMinus, faSync, faCheckCircle, farCircle);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import debounce from "lodash/debounce";
import { mapGetters } from "vuex";

export default {
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue"),
    "vue-select-multiple": () => import("@/components/VueSelectMultiple.vue"),
    DatePicker
  },
  data () {
    return {
      id_poli: null,
      syncing: false,
      synced: false,
      editName: null,
      editLocation: null,
      form: {
        status: "",
        kode: "",
        location: "",
        nama: "",
        kategori: [],
        durasi: "",
        jadwal: [
          {
            id: [],
            hari: [],
            jam_mulai: null,
            jam_selesai: null
          }
        ],
        dokter: [null]
      },
      errForm: {
        nama: "",
        kode: "",
        location: "",
        jadwal: [],
        dokter: [],
        kategori: "",
        dokter: [],
      },
      optionHari: [
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu',
        'Minggu',
        'Hari Kerja',
        '1 Minggu Total',
      ],
      optionDokter: [],
      statusPoliklinik: [
        {
          label: 'Tutup',
          value: 0,
        },
        {
          label: 'Buka',
          value: 1,
        }
      ],
      kategoriPasien: [],
      poliBpjsList: [],
      locationList: [],
    }
  },
  computed: {
    ...mapGetters(["getKlinikId", "bpjsAuthValid", "satusehatAuthValid"]),
    isTambah() {
      return this.id_poli ? false : true
    },
    isEdit() {
      return !this.isTambah
    },
    getStatus() {
      return this.form.status
    },
    getNama() {
      return this.form.nama
    },
    getLocation() {
      return this.form.location
    },
    getDurasi() {
      return this.form.durasi
    },
    getKategori() {
      return this.form.kategori
    },
    getJadwal() {
      return this.form.jadwal
    },
    getDokter() {
      return this.form.dokter
    },
  },
  watch: {
    getStatus(val) {
      if (val) this.errForm.status = '';
      else this.errForm.status = 'Kolom harus diisi'
    },
    getNama(val) {
      if (val) this.errForm.nama = '';
      else this.errForm.nama = 'Kolom harus diisi'
    },
    getLocation(val) {
      if (val) this.errForm.location = '';
      else this.errForm.location = 'Kolom harus diisi'
    },
    getDurasi(val) {
      if (val) this.errForm.durasi = '';
      else this.errForm.durasi = 'Kolom harus diisi'
    },
    getKategori(val) {
      if (val.length > 0) this.errForm.kategori = '';
      else this.errForm.kategori = 'Kolom harus diisi'
    },
    getJadwal() {
      this.form.jadwal.forEach((jadwal, i) => {
        if (jadwal.hari.length < 1 || !jadwal.jam_mulai || !jadwal.jam_selesai) {
          this.$set(this.errForm.jadwal, i, 'Kolom harus diisi')
        }
      })
    },
    getDokter() {
      this.form.dokter.forEach((dokter, i) => {
        if (!dokter) {
          this.$set(this.errForm.dokter, i, 'Kolom harus diisi')
        }
      })
    },
  },
  mounted() {
    this.id_poli = this.$router.currentRoute.params.id_poli || null;
    this.fetchKategoriPasien();
    this.fetchDokterCabang();
    this.fetchKodePoliBpjs();
    this.fetchLocation();

    if (this.isEdit) {
      this.fetchPoli();
    }
  },
  methods: {
    changeLocation($event) {
      if ($event && this.editLocation) {
        if ($event.value != this.editLocation.value) {
          this.syncing = false;
          this.synced = false;
        } else {
          this.syncing = true;
          this.synced = true;
        }
      } else {
        this.syncing = false;
        this.synced = false;
      }
    },
    syncHandler(){
      if (!this.syncing){
        if (this.validateForm()) {
          // this.syncing = true;
          this.syncSatusehat();
        } else {
          this.$swal({
            text: `Silakan cek kembali pengisian data Anda!`,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "OK",
            scrollbarPadding: false
          })
        }
      }
    },
    syncSatusehat(){
      this.syncing = true;
      axios.post(`${this.url_api}/satu-sehat/poliklinik/sync/${this.id_poli}`, {
        nama: this.form.nama,
        klinik_id: this.getKlinikId,
        status: this.form.status ? this.form.status.value : null,
        location_id: this.form.location ? this.form.location.value : null,
      })
      .then(res => {
        if (res.data.status) {
          this.synced = true;
          return;
        }
        this.synced = false;
        this.syncing = false;
        this.$swal({
          title:`Gagal melakukan Sync dengan Satu Sehat`,
          text: res.data.message,
          type: "error"
        });
        return;
      })
    },
    addJadwal() {
      this.form.jadwal.push({
        id: [],
        hari: [],
        jam_mulai: null,
        jam_selesai: null
      })
    },
    deleteJadwal(index) {
      this.form.jadwal.splice(index, 1)
      this.errForm.jadwal.splice(index, 1)
      this.validateJadwal()
    },
    addDokter() {
      this.form.dokter.push(null)
    },
    deleteDokter(index) {
      this.errForm.dokter[index] = '';
      this.form.dokter.splice(index, 1)
      this.validateDokter()
    },
    fetchKategoriPasien() {
      axios.get(`${this.url_api}/kategori-pasien?klinik_id=${this.getKlinikId}`)
        .then(res => {
          if (res.data.status) {
            this.kategoriPasien = res.data.data.map(item => {
              return {
                ...item,
                label: item.nama
              }
            })
          }
        })
    },
    fetchDokterCabang() {
      axios.get(`${this.url_api}/klinik/dokter-cabang?klinik_id=${this.getKlinikId}`)
        .then(res => {
          if (res.data.status) {
            this.optionDokter = res.data.data.map(item => {
              return {
                ...item,
                label: item.nama
              }
            })
          }
        })
    },
    async fetchLocation() {
      try {
        const res = await axios.get(
          `${this.url_api}/satu-sehat/location/${this.getKlinikId}`
        );
        const { status, data } = res.data;
    
        if (status && data.length > 0) {
          this.locationList = data.map(item => {
            let disable = true
            if(item.synced_to_satusehat && item.satusehat_location_id != null && item.satusehat_location_id != ''){
              disable = false;
            }else{
              disable = true;
            }

            if (!this.satusehatAuthValid) {
              disable = false;
            }

            return {
              value: item.id,
              label: item.name,
              name: item.name,
              // disable: disable,
            };
          });
        }
      } catch (error) {}
    },
    async fetchKodePoliBpjs() {
      try {
        const check = await axios.get( `${this.url_api}/bpjs/auth?klinik_id=${this.getKlinikId}`);
        const { status, data } = check.data;

        if (status) {
          if (data.bpjs_auth_valid) {
            const res = await axios.get(
              `${this.url_api}/bpjs/poli-fktp?klinik_id=${this.getKlinikId}&first_row=0&limit=15`
            );
            const { metaData, response} = res.data;
        
            if (metaData.code == 200) {
              this.poliBpjsList = response.list.map(item => {
                return {
                  id: item.kdPoli,
                  label: `${item.kdPoli} - ${item.nmPoli}`,
                  name: item.nmPoli
                };
              });
            }
          }
        }
      } catch (error) {}
    },
    inputKode(value) {
      if (Object(value).hasOwnProperty('label')) {
        this.form.kode = value;
        this.form.nama = value.name;

        if (value.name != '' && value.name != null && value.name != undefined) {
          this.checkName(value.name);
        }
      }
    },
    checkName(name) {
      let paramId = '';
      if (this.isEdit) {
        paramId = `&id=${this.id_poli}`
      }
      axios.get(`${this.url_api}/poliklinik/nama/cek?klinik_id=${this.getKlinikId}&nama=${name}${paramId}`)
      .then(res => {
        if (this.editName != name) {
          this.syncing = false;
          this.synced = false;
        } else {
          this.syncing = true;
          this.synced = true;
        }
        if (!res.data.status) {
          this.errForm.nama = "Nama poliklinik telah digunakan";
          return;
        }
      })
    },
    fetchPoli() {
      axios.get(`${this.url_api}/poliklinik/${this.id_poli}?klinik_id=${this.getKlinikId}`)
        .then(res => {
          const data = res.data;

          let statusPoliklinik = {};
          this.statusPoliklinik.forEach(item => {
            if (item.value == data.status) {
              statusPoliklinik = item
            }
          });

          this.form.status = statusPoliklinik
          this.form.nama = data.nama
          this.editName = data.nama
          this.form.durasi = data.durasi
          this.form.kategori = data.kategori_pasien.map(item => {
            return {
              ...item,
              label: item.nama
            }
          })
          if (data.dokter.length > 0) {
            this.form.dokter = data.dokter.map(item => {
              return {
                ...item,
                label: item.nama
              }
            })
          }
          if (res.data.bpjs_kdpoli) {
            this.form.kode = {
              id: res.data.bpjs_kdpoli,
              label: `${res.data.bpjs_kdpoli} - ${this.form.nama}`,
              name: this.form.nama
            }
          }
          if (data.location) {
            this.form.location = {
              value: data.location.id,
              name: data.location.name,
              label: data.location.name,
            }
            this.editLocation = this.form.location;
          }
          if (data.synced_to_satusehat == 1) {
            this.syncing = true;
            this.synced = true;
          } else {
            this.syncing = false;
            this.synced = false;
          }

          if (data.jadwal.length > 0) {
            const jadwal = [];
            const jdwl_jam = [...new Set(data.jadwal.map(j => `${j.jam_mulai}-${j.jam_selesai}`))];
            jdwl_jam.forEach(jj => {
              const jdwl = data.jadwal.filter(j => `${j.jam_mulai}-${j.jam_selesai}` == jj);

              const jam = jj.split('-');
              jadwal.push({
                id: jdwl.map(v => v.id),
                hari: jdwl.map(v => v.hari),
                jam_mulai: moment(jam[0], 'HH:mm').toDate(),
                jam_selesai: moment(jam[1], 'HH:mm').toDate(),
              });
            });
            this.form.jadwal = jadwal;
          }
        })
    },
    toTime(d) {
      let r = moment(d).format('HH:mm:ss')
      if (r == 'Invalid date') {
        r = moment(d, 'HH:mm:ss').format('HH:mm:ss')
      }
      return r
    },
    getForm() {
      const jadwal = [];
      JSON.parse(JSON.stringify(this.form.jadwal)).forEach(jdwl => {
        if (jdwl.hari.length > 0) {
          jdwl.hari.forEach((j, i) => {
            jadwal.push({
              id: jdwl.id[i] || null,
              hari: j,
              jam_mulai: this.toTime(jdwl.jam_mulai),
              jam_selesai: this.toTime(jdwl.jam_selesai),
            })
          })
        }
      })

      return {
        bridging_bpjs: this.bpjsAuthValid,
        bpjs_kdpoli: this.form.kode ? this.form.kode.id : null,
        bridging_satusehat: this.satusehatAuthValid,
        location_id: this.form.location ? this.form.location.value : null,
        klinik_id: this.getKlinikId,
        nama: this.form.nama,
        durasi: this.form.durasi,
        status: this.form.status ? this.form.status.value : null,
        jadwal: jadwal,
        kategori_pasien: this.form.kategori.map(item => {
          return item.id
        }),
        dokter: this.form.dokter.map(item => {
          return item.id
        }),
        sync_satusehat: this.synced ? 1 : 0,
      };
    },
    inputNama: debounce(function() {
      this.checkName(this.form.nama)
    }, 500),
    keydownDurasi(e) {
      let charCode = e.which ? e.which : e.keyCode;

      if (charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 9){
        return;
      }

      let x = parseInt(this.form.durasi + e.key)

      if (x < 1 || x > 60 || !e.key.match(/[0-9]/)) {
        e.preventDefault()
        return false;
      }
    },
    tutup() {
      this.$swal({
        title: "Keluar",
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya"
      }).then(res => {
        if (res.value) {
          this.$router.push({
            name: 'poliklinik-list'
          })
        }
      });
    },
    inputHari(data, index) {
      let selected = data[data.length-1];
      if (selected == 'Hari Kerja') this.form.jadwal[index].hari = ['Senin','Selasa','Rabu','Kamis','Jumat'];
      else if (selected == '1 Minggu Total') this.form.jadwal[index].hari = this.optionHari.filter(v => !['Hari Kerja','1 Minggu Total'].includes(v));
      this.validateJadwal()
    },
    inputJamMulai(val) {
      this.validateJadwal()
    },
    inputJamSelesai(val) {
      this.validateJadwal()
    },
    validateJadwal() {
      const jadwal = JSON.parse(JSON.stringify(this.form.jadwal))

      jadwal.forEach((x,i)=> {
        let x_mulai = moment(x.jam_mulai).format('HHmm')
        if (x_mulai == 'Invalid date') {
          x_mulai = moment(x.jam_mulai, 'HH:mm:ss').format('HHmm')
        }
        x_mulai = parseInt(x_mulai)

        let x_selesai = moment(x.jam_selesai).format('HHmm')
        if (x_selesai == 'Invalid date') {
          x_selesai = moment(x.jam_selesai, 'HH:mm:ss').format('HHmm')
        }
        x_selesai = parseInt(x_selesai)
        
        if (x_mulai > x_selesai) {
          this.errForm.jadwal[i] = 'Jam mulai harus lebih awal'
        } else {
          this.errForm.jadwal[i] = ''
        }

        jadwal.forEach((y, i2) => {
          if (i == i2) return;

          let err = false;
          if (this.checkHari(x.hari, y.hari)) {

            let y_mulai = moment(y.jam_mulai).format('HHmm')
            if (y_mulai == 'Invalid date') {
              y_mulai = moment(y.jam_mulai, 'HH:mm:ss').format('HHmm')
            }
            y_mulai = parseInt(y_mulai)

            let y_selesai = moment(y.jam_selesai).format('HHmm')
            if (y_selesai == 'Invalid date') {
              y_selesai = moment(y.jam_selesai, 'HH:mm:ss').format('HHmm')
            }
            y_selesai = parseInt(y_selesai)

            if (
              (x_mulai == y_mulai && x_selesai == y_selesai) || 
              (x_mulai > y_mulai && x_mulai < y_selesai) || 
              (y_mulai > x_mulai && y_mulai < x_selesai) ||
              x_mulai == y_mulai ||
              x_selesai == y_selesai
            ) {
              err = true;
            }
          }

          if (err) {
            this.errForm.jadwal[i] = 'Jadwal telah terdaftar'
          }
        })
      })
    },
    checkHari(h1, h2) {
      let check = false;
      for (let i in h2) {
        if (check) continue;

        if (h1.includes(h2[i])) {
          check = true;
        }
      }
      return check;
    },
    inputDokter() {
      this.validateDokter()
    },
    validateDokter() {
      const dokter = JSON.parse(JSON.stringify(this.form.dokter))

      if (dokter.length == 1) this.errForm.dokter[0] = ''

      dokter.forEach((x, i) => {
        dokter.forEach((y, i2) => {
          if (i == i2) return;
          if (x.id == y.id) {
            this.errForm.dokter[i] = 'Dokter telah terdaftar'
          }
          else {
            this.errForm.dokter[i] = ''
          }
        })
      })
    },
    validateForm() {
      let valid = true;
      
      if (!this.form.nama) {
        this.errForm.nama = 'Kolom harus diisi'
        valid = false
      }
      if (!this.form.status) {
        this.errForm.status = 'Kolom harus diisi'
        valid = false
      }
      if (!this.form.location) {
        this.errForm.location = 'Kolom harus diisi'
        valid = false
      }
      if (!this.form.durasi) {
        this.errForm.durasi = 'Kolom harus diisi'
        valid = false
      }
      
      if (this.form.kategori.length == 0) {
        this.errForm.kategori = 'Kolom harus diisi'
        valid = false;
      }

      this.form.jadwal.forEach((jadwal, i) => {
        if (jadwal.hari.length < 1 || !jadwal.jam_mulai || !jadwal.jam_selesai) {
          this.$set(this.errForm.jadwal, i, 'Kolom harus diisi')
          valid = false;
        }
      })

      this.form.dokter.forEach((dokter, i) => {
        if (!dokter) {
          this.$set(this.errForm.dokter, i, 'Kolom harus diisi')
          valid = false;
        }
      })

      if (this.errForm.status) {
        valid = false;
      }
      else if (this.errForm.nama) {
        valid = false;
      }
      else if (this.errForm.durasi) {
        valid = false;
      }
      else if (this.errForm.kategori) {
        valid = false;
      }
      this.errForm.jadwal.forEach(jadwal => {
        if (jadwal) {
          valid = false;
        }
      })
      this.errForm.dokter.forEach(dokter => {
        if (dokter) {
          valid = false;
        }
      })

      return valid
    },
    selesai() {
      if (this.validateForm()) {
        if (this.isTambah) this.create();
        else if (this.isEdit) this.update();
      }
      else {
        this.$swal({
          text: `Silakan cek kembali pengisian data Anda!`,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          scrollbarPadding: false
        })
      }
    },
    create() {
      axios.post(`${this.url_api}/poliklinik`, this.getForm())
        .then(res => {
          if (res.data.status) {
            if(this.satusehatAuthValid){
              this.$swal({
                title: "Data berhasil disimpan!", 
                html: `Data Poliklinik berhasil tersimpan <br> di sistem izidok <div class="note-blue">Catatan: izidok berhasil  melakukan sync ke SatuSehat</div>`,
                type: "success",
                confirmButtonText: "OK"
              }).then(val => {
                this.$router.push({
                  name: 'poliklinik-list'
                })
              });
              return
            }

            this.$swal({
              text: "Data berhasil disimpan!",
              type: "success",
              confirmButtonText: "OK"
            }).then(val => {
              this.$router.push({
                name: 'poliklinik-list'
              })
            });
            return;
          }
          if(this.satusehatAuthValid){
            const poliId = res.data.data.id;
            this.$swal({
              title: "Data berhasil disimpan!", 
              html: `
                Data Poliklinik berhasil tersimpan <br>
                di sistem izidok
                <div class="note-red mt-4">Catatan: izidok gagal  melakukan sync ke SatuSehat</div>
                <div class="note-red mt-2">${res.data.message}</div>
              `,
              type: "success",
              showCancelButton: true,
              cancelButtonText: 'Lanjutkan',
              confirmButtonText: 'Coba Lagi',
              cancelButtonColor: '#1bc943',
              allowOutsideClick: false,
            }).then(async res => {
              if (res.value) {
                this.syncAgain(poliId);
              } else {
                this.$router.push({
                  name: 'poliklinik-list'
                })
              }
            });
            return;
          }
          this.$swal({
            text: res.data.message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: "OK",
            scrollbarPadding: false
          })
        })
    },
    syncAgain(poliId){
      axios.post(`${this.url_api}/satu-sehat/poliklinik/sync/${poliId}`, {
        nama: this.form.nama,
        klinik_id: this.getKlinikId,
        status: this.form.status ? this.form.status.value : null,
        location_id: this.form.location ? this.form.location.value : null,
      })
      .then(res => {
        if (res.data.status) {
          this.$swal({
            title: "Data berhasil disimpan!", 
            html: `Data Poliklinik berhasil tersimpan <br> di sistem izidok <div class="note-blue">Catatan: izidok berhasil  melakukan sync ke SatuSehat</div>`,
            type: "success",
            confirmButtonText: "OK"
          }).then(val => {
            this.$router.push({
              name: 'poliklinik-list'
            })
          });
          return
        }
        this.$swal({
          // title: "Data berhasil disimpan!", 
          html: `izidok gagal melakukan sync ke SatuSehat <div class="note-red mt-4">Catatan: ${res.data.message}</div>`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: 'Lanjutkan',
          confirmButtonText: 'Coba Lagi',
          cancelButtonColor: '#1bc943',
          allowOutsideClick: false,
        }).then(async res => {
          if (res.value) {
            this.syncAgain(poliId);
          } else {
            this.$router.push({
              name: 'poliklinik-list'
            })
          }
        });
        return;
      })
    },
    update() {
      axios.put(`${this.url_api}/poliklinik/${this.id_poli}`, this.getForm())
      .then(res => {
        if (res.data.status) {
          if(this.satusehatAuthValid){
            this.$swal({
              title: "Data berhasil disimpan!", 
              html: `Data Poliklinik berhasil tersimpan <br> di sistem izidok <div class="note-blue">Catatan: izidok berhasil  melakukan sync ke SatuSehat</div>`,
              type: "success",
              confirmButtonText: "OK"
            }).then(val => {
              this.$router.push({
                name: 'poliklinik-list'
              })
            });
            return
          }
          
          this.$swal({
            text: "Data berhasil disimpan!",
            type: "success",
            confirmButtonText: "OK"
          }).then(val => {
            this.$router.push({
              name: 'poliklinik-list'
            })
          });
          return;
        }

        if(this.satusehatAuthValid){
          this.$swal({
            title: "Data berhasil disimpan!", 
            html: `
              Data Poliklinik berhasil tersimpan <br>
              di sistem izidok
              <div class="note-red mt-4">Catatan: izidok gagal  melakukan sync ke SatuSehat</div>
              <div class="note-red mt-2">${res.data.message}</div>
            `,
            type: "success",
            showCancelButton: true,
            cancelButtonText: 'Lanjutkan',
            confirmButtonText: 'Coba Lagi',
            cancelButtonColor: '#1bc943',
            allowOutsideClick: false,
          }).then(async res => {
            if (res.value) {
              await this.syncAgain(this.id_poli);
            } else {
              this.$router.push({
                name: 'poliklinik-list'
              })
            }
          });
          return;
        }

        this.$swal({
          text: res.data.message,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: "OK",
          scrollbarPadding: false
        })
      })
    }
  }
}
</script>
<style>
  .schedule {
    border: 2px solid rgb(127 173 219);
    border-radius: 5px;
    padding: 20px;
    margin: 20px 0;
  }

  .schedule-number, .schedule-button {
    margin: auto 0;
  }

  .vdatetime input[type="text"] {
    display: block;
    width: 100%;
    height: calc( 1.5em + 1.06rem + 2px );
    padding: 0.53rem 1.3rem;
    font-size: 0.95rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3b3e66;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d1d2db;
    border-radius: 0.29rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .select-multiple .vs__search {
    padding: .3rem .4rem !important;
  }
  .poli-tambah .vs__search {
    color: rgba(0,0,0,.4)
  }

  .mx-datepicker {
    width: 100%;
  }

  .mx-input {
    height: 40px !important;
    border-radius: 5px;
  }
  div.sync {
    display: flex;
    align-items: center;
    margin-top: 1.75rem !important;
  }
  .pointer {
    cursor: pointer;
  }
  .icon-sync {
    color:#11c5db;
    border: 1px solid #eee;
    padding: 4px;
    border-radius: 50%;
    font-size: 22px;
  }
  .icon-circle-check {
    color:#1bbf2c;
    font-size: 22px;
  }
  .select-multiple .vs__dropdown-toggle .vs__selected-options .vs__selected {
    height: 30px !important;
  }
  .vue-select-custom .vs__dropdown-toggle .vs__selected-options label {
    margin: 0 !important;
  }

  .note-blue {
    color: #3085d6;
    font-weight: 100;
    font-size: 14px;
    padding-top: 10px;
  }

  .note-red {
    color: red;
    font-weight: 100;
    font-size: 14px;
  }
</style>